import React from "react"
import FlatButton from "material-ui/FlatButton"
import { IHierarchyItem } from "../../models"
import HierarchySettingsStore from "../../stores/HierarchySettingsStore"
interface IProps {
    disabled: boolean
    hierarchy: IHierarchyItem
    hierarchyName: string
    hierarchyDefinitionName: string
    onClick(hierarchy: IHierarchyItem): void
}

const HierarchyBreadCrumbItem: React.SFC<IProps> = (props: IProps) => {
    return (
        <div style={{ float: "left" }}>
            {props.hierarchyName &&
                <div>
                    <div style={{ float: "left" }}>
                        <div style={{ marginBottom: 0, paddingLeft: 15, color: "#b8b9bd" }}>
                            {props.hierarchyDefinitionName}
                        </div>
                        <FlatButton
                            style={{ height: 65, maxWidth: 500, lineHeight: "20px", wordBreak: "break-word" }}
                            labelStyle={{ fontSize: 18 }}
                            label={props.hierarchyName}
                            onTouchTap={() => props.onClick && props.onClick(props.hierarchy)}
                            disabled={props.disabled}
                        />
                    </div>
                    <div style={{ float: "left", padding: "35px 0px 0px 5px", color: "#b8b9bd" }}>
                        {HierarchySettingsStore.checkHierarchyHasChildHierarchy(props.hierarchy.Id) &&
                            <i className="fa fa-angle-right" style={{ fontSize: 30 }} />
                        }
                    </div>
                    <div style={{ clear: "both" }} />
                </div>
            }
        </div>
    )
}

export default HierarchyBreadCrumbItem
